import { REQUEST_TYPE } from "./constants";
import type { Claim } from "./types";

type ThankYouCopyKeys = {
  body: string;
  cta: string;
};

const REQUEST_COPY: Record<string, ThankYouCopyKeys> = {
  [REQUEST_TYPE.RETURN]: {
    body: "thanks.returnBody",
    cta: "thanks.returnCta",
  },
  [REQUEST_TYPE.EXCHANGE]: {
    body: "thanks.exchangeBody",
    cta: "thanks.exchangeCta",
  },
};

const CLAIM_COPY: ThankYouCopyKeys = {
  body: "thanks.body",
  cta: "thanks.cta",
};

export const thankYouCopyKeys = (
  claim: Claim | null | undefined,
  hasReturnLabel: boolean,
): ThankYouCopyKeys => {
  const copy = REQUEST_COPY[claim?.request_type ?? ""] ?? CLAIM_COPY;
  return hasReturnLabel ? { ...copy, body: "thanks.returnLabelBody" } : copy;
};
